export type CentralNavigationChild = {
  readonly title: string;
  readonly href: string;
  readonly shortTitle?: string;
};

export type CentralNavigationItem = {
  readonly title: string;
  readonly href: string;
  readonly icon: string;
  readonly children?: readonly CentralNavigationChild[];
  readonly activePrefixes?: readonly string[];
};

export type CentralNavigation = {
  readonly desktop: readonly CentralNavigationItem[];
  readonly mobile: readonly CentralNavigationItem[];
};

/** Guest-register launch navigation. Other workspaces remain available by direct route. */
const navigation: readonly CentralNavigationItem[] = [
  { title: "Cases", href: "/workspace/case-list", icon: "cases", activePrefixes: ["/workspace/case-overview"] },
  { title: "Events", href: "/events", icon: "events", activePrefixes: ["/registry", "/workspace/event-calendar", "/workspace/online-registry"] },
];

export const CENTRAL_NAVIGATION = {
  desktop: navigation,
  mobile: navigation,
} as const satisfies CentralNavigation;

export function isCentralNavigationRouteActive(currentPath: string, href: string): boolean {
  if (href === "/") {
    return currentPath === "/";
  }

  return currentPath === href || currentPath.startsWith(`${href}/`);
}

export function isCentralNavigationItemActive(
  currentPath: string,
  item: CentralNavigationItem,
): boolean {
  if (isCentralNavigationRouteActive(currentPath, item.href)) {
    return true;
  }

  if (item.children?.some((child) => isCentralNavigationRouteActive(currentPath, child.href))) {
    return true;
  }

  return item.activePrefixes?.some((prefix) => currentPath.startsWith(prefix)) ?? false;
}

export function getCentralNavigationContext(
  currentPath: string,
): CentralNavigationItem | null {
  return CENTRAL_NAVIGATION.mobile.find(
    (item) => item.children?.length && isCentralNavigationItemActive(currentPath, item),
  ) ?? null;
}
